import React, { useState, useEffect, useRef } from 'react';
import './RouletteWheel.css';

const RouletteWheel = ({ members, onComplete }) => {
  const [isSpinning, setIsSpinning] = useState(false);
  const [rotation, setRotation] = useState(0);
  const [winner, setWinner] = useState(null);
  const wheelRef = useRef(null);
  const canvasRef = useRef(null);

  const colors = [
    '#FF6B6B', '#4ECDC4', '#45B7D1', '#FFA07A', '#98D8C8',
    '#F7DC6F', '#BB8FCE', '#85C1E2', '#F8B739', '#52B788'
  ];

  useEffect(() => {
    drawWheel();
  }, [members]);

  const drawWheel = () => {
    const canvas = canvasRef.current;
    if (!canvas || members.length === 0) return;

    const ctx = canvas.getContext('2d');
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    const radius = canvas.width / 2 - 10;
    const segmentAngle = (2 * Math.PI) / members.length;

    ctx.clearRect(0, 0, canvas.width, canvas.height);

    members.forEach((member, index) => {
      const startAngle = index * segmentAngle - Math.PI / 2;
      const endAngle = startAngle + segmentAngle;

      // Draw segment
      ctx.beginPath();
      ctx.moveTo(centerX, centerY);
      ctx.arc(centerX, centerY, radius, startAngle, endAngle);
      ctx.closePath();
      ctx.fillStyle = colors[index % colors.length];
      ctx.fill();
      
      // Draw border
      ctx.strokeStyle = 'rgba(255, 255, 255, 0.3)';
      ctx.lineWidth = 2;
      ctx.stroke();

      // Draw text
      ctx.save();
      ctx.translate(centerX, centerY);
      ctx.rotate(startAngle + segmentAngle / 2);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = '#FFFFFF';
      ctx.font = 'bold 16px Arial, sans-serif';
      ctx.shadowColor = 'rgba(0, 0, 0, 0.8)';
      ctx.shadowBlur = 4;
      ctx.shadowOffsetX = 2;
      ctx.shadowOffsetY = 2;
      
      // Truncate long names
      let displayName = member.name;
      if (displayName.length > 12) {
        displayName = displayName.substring(0, 10) + '...';
      }
      
      ctx.fillText(displayName, radius * 0.65, 0);
      ctx.restore();
    });

    // Draw center circle
    ctx.beginPath();
    ctx.arc(centerX, centerY, 50, 0, 2 * Math.PI);
    ctx.fillStyle = '#2C3E50';
    ctx.fill();
    ctx.strokeStyle = '#FFFFFF';
    ctx.lineWidth = 5;
    ctx.stroke();
  };

  const startSpin = () => {
    if (isSpinning || members.length === 0) return;

    setIsSpinning(true);
    setWinner(null);

    // Random winner index
    const winnerIndex = Math.floor(Math.random() * members.length);
    const segmentAngle = 360 / members.length;
    
    // Calculate final rotation (5-8 full rotations + winner position)
    const spins = 5 + Math.random() * 3;
    const extraDegrees = Math.random() * segmentAngle;
    const finalRotation = (spins * 360) + (winnerIndex * segmentAngle) + extraDegrees;
    
    setRotation(finalRotation);

    // After animation completes
    setTimeout(() => {
      setIsSpinning(false);
      setWinner(members[winnerIndex]);
      if (onComplete) {
        onComplete(members[winnerIndex]);
      }
    }, 6000);
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      startSpin();
    }, 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="roulette-container">
      <div className="roulette-pointer">▼</div>
      
      <div className="wheel-wrapper">
        <canvas
          ref={canvasRef}
          width="500"
          height="500"
          className={`roulette-canvas ${isSpinning ? 'spinning' : ''}`}
          style={{
            transform: `rotate(${rotation}deg)`,
            transition: isSpinning ? 'transform 6s cubic-bezier(0.17, 0.67, 0.30, 0.99)' : 'none'
          }}
        />
        <div className="wheel-center-emoji">🎰</div>
      </div>

      {!isSpinning && winner && (
        <div className="winner-announcement">
          <h3>🎉 Pemenang!</h3>
          <p className="winner-name">{winner.name}</p>
        </div>
      )}
    </div>
  );
};

export default RouletteWheel;
